import { render, staticRenderFns } from "./SpecialtyChangeActivationType.vue?vue&type=template&id=5051dd34&"
import script from "./SpecialtyChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SpecialtyChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports